import React from 'react';
import {Button, Divider, NavBar} from 'antd-mobile';
import {getNavBarContainerStyle, getBottomNavBarContainerStyle} from "../../../../utils/deviceUtils";
import {ArrowLeftOutlined} from '@ant-design/icons';
import {useLocation, useNavigate} from 'react-router-dom';
import {DspPath} from "../../../../enums/DeliveryNavigatePathEnum";
import {gql, useMutation} from "@apollo/client";
import {t} from "../../../../i18n";

type OrderItem = {
    id: string;
    route: string;
    stopNumber: string;
};

type PageState = {
    stats: {
        orderTotal: number;
        scannedTotal: number;
    };
    notScannedOrders: OrderItem[];
    visitor: string;
};

const HANDLE_DSP_ARRIVAL_DELIVERY_EVENT = gql`
  mutation DeliveryMutation {
    handleDspArrivalDeliveryEvent {
        success
    }
  }
`;

const ReceivingSortingConfirmPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as PageState;
    const [handleDspOutForDelivery] = useMutation(HANDLE_DSP_ARRIVAL_DELIVERY_EVENT);
    
    const handleStartAnyway = async () => {
        try {
            await handleDspOutForDelivery();
            navigate(DspPath.DELIVERY_DSP_HOME);
        } catch (error) {
            console.error('handleDspStartAnyway error:', error);
        }
    };

    if (!state) {
        navigate(DspPath.DELIVERY_DSP_HOME);
    }

    return (
        <div className="flex flex-col h-screen">
            <div {...getNavBarContainerStyle()}>
                <NavBar onBack={() => navigate(-1)} backIcon={<ArrowLeftOutlined/>}></NavBar>
            </div>

            <div className="flex-1 overflow-auto p-4 gap-2">
                {/* 统计信息 */}
                <div className="flex flex-col gap-1 font-semibold">
                    <div>{t('pages.dsp.home.receivingSorting.confirmPage.ordersAssigned')} : {state.stats.orderTotal}</div>
                    <div>{t('pages.dsp.home.receivingSorting.confirmPage.scannedSuccessfully')} : {state.stats.scannedTotal}</div>
                </div>

                <Divider/>

                {/* 未扫描的订单 */}
                <div className="">
                    <div className="font-semibold mb-2">{t('pages.dsp.home.receivingSorting.confirmPage.ordersNotScanned')} : {state.notScannedOrders.length}</div>
                    {state.notScannedOrders.map((order) => (
                        <div key={order.id} className="mb-1 text-sm pl-4">
                            {order.id} - {order.stopNumber} - {order.route}
                        </div>
                    ))}
                </div>

                <Divider />
            </div>

            {/* 警告提示 */}
            {/*<div className="text-orange-500 p-6 py-4">*/}
            {/*    <div className="text-sm">*/}
            {/*        Note: If you complete anyway, the unScanned packages will be reported as exceptions.*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/* 底部按钮 */}
            <div {...getBottomNavBarContainerStyle('flex gap-3 mb-4 justify-center')}>
                {/*<Button onClick={handleStartAnyway} color='default'>*/}
                {/*    {t('pages.dsp.home.receivingSorting.confirmPage.completeAnyway')}*/}
                {/*</Button>*/}
                <Button onClick={()=>navigate(-1)} color="primary">
                    {t('pages.dsp.home.receivingSorting.confirmPage.continueScanning')}
                </Button>
            </div>
        </div>
    );
};

export default ReceivingSortingConfirmPage;